export const IS_REFRESHING = 'attachment/IS_REFRESHING';
export const LIST_REQUEST = 'attachment/LIST_REQUEST';
export const LIST_SUCCESS = 'attachment/LIST_SUCCESS';
